module.exports = __webpack_public_path__ + "img/milestone__1888.e079587e.jpg";